var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from 'react-redux';
import configureMockStore from 'redux-mock-store';
var defaultState = {};
var mockStore = configureMockStore();
export var withStore = function (state) {
    if (state === void 0) { state = defaultState; }
    return function (Story, options) {
        var args = options.args, parameters = options.parameters;
        if (parameters.modifyArgs) {
            Object.assign(args, parameters.modifyArgs(args));
        }
        return (_jsx(Provider, __assign({ store: mockStore(options.args.state || state) }, { children: _jsx(Story, {}) })));
    };
};
